export function setCursorToEnd(element) {
    if (!element) {
        return;
    }
    var end = element.value.length;
    element.setSelectionRange(end, end);
}
